module.exports = __webpack_public_path__ + "img/inco6.93965bde.png";